type PatientId = number;
type PrintTemplateId = number;

export const getDocumentTemplateToken = (patientId: PatientId, printTemplateId: PrintTemplateId): string =>
   `visit-patient-${patientId}-documentTemplate-${printTemplateId}`;
